
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import { AccessibilityButton } from "@/components/AccessibilityButton";
import { PreferenciasForm } from "@/components/Preferencias/PreferenciasForm";

export default function Preferencias() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <section className="py-16">
        <div className="container mx-auto px-6">
          <div className="max-w-2xl mx-auto">
            <h1 className="text-3xl font-bold text-gray-800 mb-8 text-center">
              Preferências
            </h1>
            <PreferenciasForm />
          </div>
        </div>
      </section>

      <Footer />
      <FloatingWhatsApp />
      <AccessibilityButton />
    </div>
  );
}
